import { gql } from '@apollo/client';

export const ALL_MESSAGES_QUERY_NAME = 'AllMessages';
export const ALL_MESSAGES = gql`
    query ${ALL_MESSAGES_QUERY_NAME}(
        $sortField: String, 
        $sortOrder: String, 
        $page: Int, 
        $perPage: Int
    ) {
        allMessages(
            sortField: $sortField, 
            sortOrder: $sortOrder, 
            page: $page, 
            perPage: $perPage
        ) {
            totalCount
            models {
                id
                messageKey
                params
                messageScope
                severity
                lastUpdateTime
            }
        }
    }
`;

export const ON_MESSAGE_CHANGED = gql`
    subscription onMessageChanged {
        messageChanged {
            correlationId
            action
            model {
                id
                messageKey
                params
                messageScope
                severity
                lastUpdateTime
            }
        }
    }
`;

export const CREATE_MESSAGE = gql`
    mutation CreateMessage(
        $message: String!, 
        $correlationId: String!
    ) {
        createMessage(
            message: $message, 
            correlationId: $correlationId
        ) {
            id
        }
    }
`;
